import { IS_NOT, NO, UIButton, UIButtonColorSpecifier, UIColor, UIComponentView, UIView } from "uicore-ts"
import { CBEditorNestedAttributes } from "../../CBEditorDecorators"
import { CBColor } from "./CBColor"


// injectCSS(
//     // language=CSS
//     `
//        
//         .UICore_UIView_CBButton {
//            
//             background: rgba(255, 255, 255, 0.51);
//             border-radius: 16px;
//             box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
//             backdrop-filter: blur(17.6px);
//             -webkit-backdrop-filter: blur(17.6px);
//             border: 1px solid rgba(255, 255, 255, 0.41);
//            
//         }
//    
//     `,
//     "UICore_UIView_CBButton_Styles"
// )


@UIComponentView
export class CBButton extends UIButton {
    
    @CBEditorNestedAttributes()
    override get titleLabel() {
        return super.titleLabel
    }
    
    @CBEditorNestedAttributes(2)
    override colors: UIButtonColorSpecifier = {
        
        titleLabel: {
            
            normal: UIColor.whiteColor,
            highlighted: UIColor.whiteColor.colorWithAlpha(0.8),
            selected: UIColor.whiteColor.colorWithAlpha(0.8)
            
        },
        
        background: {
            
            normal: UIColor.transparentColor,
            highlighted: UIColor.greenColor,
            selected: UIColor.redColor
            
        }
        
    }
    
    backgroundView = new UIView().configuredWithObject({
        userInteractionEnabled: NO,
        // alpha: 0.7,
        // style: { backdropFilter: "blur(20px) saturate(1.1)" }
    }).addedAsSubviewToView(this)
    borderView = new UIView().configuredWithObject({
        userInteractionEnabled: NO
    }).addedAsSubviewToView(this.backgroundView)
    
    
    constructor(elementID?: string, elementType?: string) {
        
        super(elementID, elementType)
        
        this.style.outline = "none"
        
        
        this.setBackgroundColorsWithNormalColor(CBColor.primaryTintColor)
        
        this.colors.titleLabel.selected = CBColor.primaryTintColor
        
    }
    
    
    
    setBackgroundColorsWithNormalColor(normalBackgroundColor: UIColor) {
        
        this.colors.background.normal = normalBackgroundColor
        this.colors.background.hovered = UIColor.colorWithRGBA(40, 168, 183)
        this.colors.background.focused = normalBackgroundColor
        this.colors.background.highlighted = UIColor.colorWithRGBA(32, 140, 154)
        // this.colors.background.highlighted = UIColor.colorWithRGBA(48, 196, 212)
        this.colors.background.selected = UIColor.whiteColor
        
        this.updateContentForCurrentState()
        
    }
    
    
    
    
    override get backgroundColor() {
        return this._backgroundColor
    }
    
    override set backgroundColor(backgroundColor: UIColor) {
        this._backgroundColor = backgroundColor
        this.backgroundView.style.backgroundColor = backgroundColor.stringValue
    }
    
    override updateContentForNormalState() {
        
        super.updateContentForNormalState()
        
        // this.setBorder(0, 0)
        
    }
    
    
    override updateContentForHoveredState() {
        
        super.updateContentForHoveredState()
        
        // this.setBorder(0, 0)
        
    }
    
    override updateContentForFocusedState() {
        
        super.updateContentForFocusedState()
        
        // this.setBorder(0, 1, CBColor.primaryContentColor)
        
    }
    
    
    override updateContentForHighlightedState() {
        
        super.updateContentForHighlightedState()
        
        // this.setBorder(0, 0)
        
    }
    
    
    override updateContentForCurrentEnabledState() {
        
        super.updateContentForCurrentEnabledState()
        
        if (IS_NOT(this.enabled)) {
            
            this.titleLabel.textColor = new UIColor("#adadad")
            
            this.backgroundColor = new UIColor("#e5e5e5")
            
            this.alpha = 1
            
        }
        
    }
    
    
    override layoutSubviews() {
        
        super.layoutSubviews()
        
        const bounds = this.bounds
        
        this.backgroundView.frame = bounds
        this.backgroundView.moveToBottomOfSuperview()
        this.borderView.frame = bounds
        
        
        const borderRadius = [bounds.height, bounds.width].min() * 0.5
        this.borderView.setBorder(borderRadius)
        this.backgroundView.setBorder(borderRadius, 0, UIColor.greyColor.colorWithAlpha(0.8))
        
        
        // const zoom = window.innerWidth / window.screen.width;
        //
        // const cssPxPerPhysicalPixel = zoom //(1 / (window.devicePixelRatio / zoom))
        // const borderFadeWidth = 2 * cssPxPerPhysicalPixel * 2
        //
        // this.borderView.setBorder(16, borderFadeWidth, UIColor.greyColor.colorWithAlpha(0.8))
        // this.borderView.frame = bounds//.rectangleWithInset(borderFadeWidth * 0.5)
        //     //.rectangleByAddingY(-borderFadeWidth * 1.01)
        //     // .rectangleByAddingX(-borderFadeWidth * 3)
        // //.rectangleWithInset(borderFadeWidth * 0.5)//.rectangleByAddingY(-0.5).rectangleByAddingX(-0.5)
        // this.backgroundView.setBorder(16, 0)
        // this.setBorder(16, 0)
        //
        // CBStylingUtils.applyDynamicFeatherMask(this.backgroundView.viewHTMLElement, borderFadeWidth, borderFadeWidth * 0.5, borderFadeWidth * 0.5)
        //
        //
        //
        this.style.filter = //"drop-shadow(0 16px 40px rgba(0, 0, 0, 0.22)) " +
        "drop-shadow(0 4px 16px rgba(0, 0, 0, 0.12)) " +
        "drop-shadow(0 0 1px rgba(0, 0, 0, 0.1))"
        
            // "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.15)) " +
            // "drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1)) " +
            // "drop-shadow(0 10px 20px rgba(0, 0, 0, 0.08))"
        
        
        
    }
    
    
}



























